// Central test-id registry
export const TID = {
    nav: {
        root: "site-nav",
        home: "nav-home-link",
        about: "nav-about-link",
        prestations: "nav-prestations-dropdown",
        tarifs: "nav-tarifs-link",
        contact: "nav-contact-link",
        faq: "nav-faq-link",
        entreprises: "nav-entreprises-link",
        book: "nav-book-button",
        mobileToggle: "nav-mobile-toggle",
    },
    hero: {
        book: "hero-book-button",
        discover: "hero-discover-button",
    },
    bento: (slug) => `bento-card-${slug}`,
    prestation: {
        book: (slug) => `prestation-book-${slug}`,
    },
    contact: {
        form: "contact-form",
        name: "contact-name",
        email: "contact-email",
        phone: "contact-phone",
        motif: "contact-motif",
        preference: "contact-preference",
        message: "contact-message",
        submit: "contact-submit",
        callBtn: "contact-call-button",
        emailBtn: "contact-email-button",
    },
    floating: {
        call: "floating-call",
        message: "floating-message",
    },
    footer: "site-footer",
};
